// import { Switch, Route } from "react-router";
// import ListGroups from "./Components/ListGroups";
// import DetailGroup from "./Components/DetailGroup";
import CircularProgress from '@mui/material/CircularProgress';

const Group = () => {


    return (
        <div className="w-full text-center pt-100">
            <CircularProgress color="primary" size="10rem" />
        </div>
        // <div>
        //     <Switch>
        //         <Route path="/app/group/:id"
        //             render={() => <DetailGroup />} 
        //         /> 
        //         <Route path="/app/group"
        //             render={() => <ListGroups />}
        //         />

        //     </Switch>
        // </div>
    )
}

export default Group;